module.exports = __webpack_public_path__ + "static/img/smart-warning1.ac596b3f.svg";